import { Component, inject } from '@angular/core';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {MatBadge} from '@angular/material/badge';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {AsyncPipe} from '@angular/common';
import {selectLatestNotifications, selectNotificationsUnreadCount} from '../../state/notification.selectors';
import {Store} from '@ngrx/store';
import {NotificationActions} from '../../state/notification.actions';
import {NotificationCardComponent} from '../notification-card/notification-card.component';
import {TranslatePipe} from '@ngx-translate/core';
import {map} from 'rxjs';
import {RouterLink} from '@angular/router';
import {RouteConstants} from '../../../../shared/constants/route-constants';

@Component({
  selector: 'app-header-notification',
  imports: [
    IconComponent,
    MatMenu,
    MatMenuTrigger,
    MatBadge,
    AsyncPipe,
    NotificationCardComponent,
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './header-notification.component.html',
  styleUrl: './header-notification.component.scss'
})
export class HeaderNotificationComponent {
  private store = inject(Store);

  unreadCount$ = this.store.select(selectNotificationsUnreadCount).pipe(
    map(v => v <= 0 ? null : v > 99 ? '99+' : v)
  )
  notificationList$ = this.store.select(selectLatestNotifications)

  onMarkAsRead(id: string) {
    this.store.dispatch(NotificationActions.public.markAsRead({id: id}))
  }

  protected readonly RouteConstants = RouteConstants;
}
